/* @flow */
import React from 'react'

import './style.css'

class Checkbox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      checked: false || props.checked
    }
    this.toggle = this.toggle.bind(this)
  }

  toggle(event) {
    this.setState({
      checked: !this.state.checked
    })
    this.props.onChange && this.props.onChange(!this.state.checked ? event.target.value : false)
  }

  render() {
    const { className, value, disabled } = this.props
    return <div className={'checkbox caerulus ' + (className && className)}>
      <i className="icon icon-checkbox check" />
      <input type="checkbox"
        value={value}
        checked={this.state.checked}
        onChange={this.toggle}
        disabled={disabled} />
      <i className="icon icon-checked check checked" />
    </div>
  }
}

export default Checkbox


// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js